// extracted by mini-css-extract-plugin
export var cartContainer = "_kr-4";
export var gray = "_kr-1";
export var itemContainer = "_kr-2";
export var itemDetails = "_kr-3";
export var strong = "_kr-0";